<div class="PolicyDashboard">
    <div class="Loading"  *ngIf="isShowLoading==true">
        <img id="" src="assets/img/762.gif"   />
        <label>{{'Please Wait,Processing..'|translate }}</label>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>
            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                <div class="col-md-12 proposals">
                    <div class="panel panel-default panel-table">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col col-xs-6">
                                    <h3 class="panel-title">{{'Payment Gateway' | translate }}</h3>
                                </div>
                            </div>
                        </div>
                        <div class="panel-body">
                            <div class="PaymentForm">
                                <div class="row Field">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label>{{'Proposal Number' | translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <input type="text" class="form-control" [disabled]="true" name="txtProposalNo" id="txtProposalNo" [(ngModel)]="paymentReq.proposalNo">
                                    </div>
                                </div>
                                <div class="row Field">
                                    <div class="col-lg-4  col-md-4 col-sm-12 col-xs-12">
                                        <label>{{'Name'| translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <input type="text" class="form-control" [disabled]="true" name="txtName" id="txtName" [(ngModel)]="paymentReq.InsuredName">
                                    </div>
                                </div>
                                <div class="row Field">
                                    <div class="col-lg-4  col-md-4 col-sm-12 col-xs-12">
                                        <label>{{'Premium' | translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <!-- <input type="text" class="form-control" [disabled]="true" name="txtPremium" id="txtPremium" [ngModel]="paymentReq.TotalPremium | number : '1.2-2'"> -->
                                        <input type="text" class="form-control" [disabled]="true" name="txtPremium" id="txtPremium" [ngModel]="TotalAmount | number : '1.2-2'">
                                    </div>
                                </div>
                                <div class="row Field">
                                    <div class="col-lg-4  col-md-4 col-sm-12 col-xs-12">
                                        <label>{{'Selected method' | translate }}</label>
                                    </div>
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <div class="col-sm-5 selectedpmethod_ar" *ngIf="PaymentMethod=='CR'">
                                            <img src="assets/img/visaandmaster.png" height="60px" width="170px" style="margin-top:8px; margin-left:8px;">
                                        </div>
                                        <div class="col-sm-5 selectedpmethod_ar" *ngIf="PaymentMethod=='SD'">
                                            <img src="assets/img/sadad1.png" height="60px" width="170px" style="margin-top:8px; margin-left:8px;">
                                        </div>
                                        <div class="col-sm-5 selectedpmethod_ar" *ngIf="PaymentMethod=='MD'">
                                            <img src="assets/img/mada.png" height="60px" width="170px" style="margin-top:8px; margin-left:8px;">
                                        </div>
                                        
                                    </div>
                                </div>
                                <ng-container *ngIf="fortReq.trObj.PMethod=='CR'">
                                    <form method="post" action="https://checkout.payfort.com/FortAPI/paymentPage" id="form1" name="form1" ngNoForm>
                                        <input type="hidden" name="access_code" value="{{fortReq.access_code}}">
                                        <input type="hidden" name="amount" value="{{fortReq.amount}}">
                                        <input type="hidden" name="currency" value="{{fortReq.currency}}">
                                        <input type="hidden" name="customer_email" value="{{fortReq.customer_email}}">
                                        <input type="hidden" name="merchant_reference" value="{{fortReq.merchant_reference}}">
                                        <input type="hidden" name="order_description" value="{{fortReq.order_description}}">
                                        <input type="hidden" name="language" value="{{fortReq.language}}">
                                        <input type="hidden" name="merchant_identifier" value="{{fortReq.merchant_identifier}}">
                                        <input type="hidden" name="command" value="{{fortReq.command}}">
                                        <input type="hidden" name="signature" value="{{fortReq.signature}}">
                                        <input type="hidden" name="return_url" value="{{fortReq.return_url}}">
                                        <div class="row rowSpacer">
                                            <div class="text-center col-lg-12">
                                                <div class="buttonpay">
                                                    <button id="btnfortconfirm" type="submit" class="btn btn-primary">{{'Pay' | translate }}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </ng-container>
                                <ng-container *ngIf="fortReq.trObj.PMethod=='SD'">
                                    <form method="post" action="https://checkout.payfort.com/FortAPI/paymentPage" id="form1" name="form1" ngNoForm>
                                        <input type="hidden" name="access_code" value="{{fortReq.access_code}}">
                                        <input type="hidden" name="amount" value="{{fortReq.amount}}">
                                        <input type="hidden" name="currency" value="{{fortReq.currency}}">
                                        <input type="hidden" name="customer_email" value="{{fortReq.customer_email}}">
                                        <input type="hidden" name="merchant_reference" value="{{fortReq.merchant_reference}}">
                                        <input type="hidden" name="order_description" value="{{fortReq.order_description}}">
                                        <input type="hidden" name="language" value="{{fortReq.language}}">
                                        <input type="hidden" name="merchant_identifier" value="{{fortReq.merchant_identifier}}">
                                        <input type="hidden" name="command" value="{{fortReq.command}}">
                                        <input type="hidden" name="signature" value="{{fortReq.signature}}">
                                        <input type="hidden" name="return_url" value="{{fortReq.return_url}}">
                                        <input type="hidden" name="payment_option" value="{{fortReq.payment_option}}">
                                        <div class="row rowSpacer">
                                            <div class="text-center col-lg-12">
                                                <div class="buttonpay">
                                                    <button id="btnfortconfirm" type="submit" class="btn btn-primary">{{'Pay' | translate }}</button>
                                                </div>
                                          </div>
                                        </div>
                                    </form>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Payfort/PayfortConfirm/PayfortConfirm.html